import { Dimensions } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';

const dimension = Dimensions.get('window');

const mainContainer = {
  width: '100%',
  height: '100%',
  maxHeight: dimension.height - 55,
  minHeight: dimension.height - 55,
  padding: 30,
  overflow: 'auto',
  backgroundColor: Colors.grey5,
};

const mainChildContainer = {
  width: '80%',
  maxWidth: 786,
};

const mainTitleContainer = {
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 25,
};

const mainChildRadius = {
  borderRadius: 10,
};

const titleSection = {
  fontSize: 18,
  marginBottom: 25,
};

const backSection = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  alignSelf: 'flex-start',
  marginBottom: 25,
  ...(isWeb ? { cursor: 'pointer' } : {}),
};

const backSectionIcon = {
  height: 15,
  marginRight: 20,
};

const backSectionText = {
  fontSize: 14,
  lineHeight: 16,
};

export {
  mainContainer,
  titleSection,
  backSection,
  backSectionIcon,
  backSectionText,
  mainChildContainer,
  mainChildRadius,
  mainTitleContainer,
};
